export default __webpack_public_path__ + "static/media/ambulant.fbbd02ec.svg";